import { FunctionComponent, useEffect } from "react";
import styles from "./CheckoutPagamentoCartaoErro.module.css";
import { Header } from "../../components/Header";
import { useCheckout } from "../../context/CheckoutContext";
import { useNavigate, useParams } from "react-router-dom";

const CheckoutPagamentoCartaoErro: FunctionComponent = () => {
  const {
    paymentType
  } = useCheckout()
  const params = useParams();

  const { cart, setCard, card } = useCheckout();
  
  useEffect(() => {
    setCard({...card, security_code: ''})
    if (cart.length === 0) params.slug ? navigate(`/${params.slug}`) : navigate("/")
  }, [])

  const navigate = useNavigate();
  return (
    <div className={styles.checkoutPagamentoCartaoErro}>
      <div className={styles.header}>
        <Header path="none" />
      </div>
      <div className={styles.reprovado}>
        <img
          className={styles.httpslottiefilescomanimatIcon}
          alt=""
          src="/httpslottiefilescomanimationserrorqgiqwiypnv@2x.png"
        />
        <div className={styles.info}>
          <div className={styles.opaPagamentoNo}>
            {
              paymentType === 'Pix' && 'Opa, houve um problema ao gerar o pix'
            }
            {
              paymentType === 'Boleto' && 'Opa, houve um problema ao gerar o boleto'
            }
            {
              paymentType === 'Cartão' && 'Opa, pagamento não aprovado.'
            }
          </div>
          <div className={styles.houveUmProblemaContainer}>
            <p className={styles.opaPagamentoNo}>
            {
              paymentType === 'Boleto' && 'Houve um problema durante a geração do boleto'
            }
            {
              paymentType === 'Pix' && 'Houve um problema durante a geração do pix'
            }
            {
              paymentType === 'Cartão' &&  'Houve um problema durante o processamento da transação, e o pagamento não foi aprovado.'
            }
            </p>
            <p className={styles.houveUmProblema}>&nbsp;</p>
            <p className={styles.houveUmProblema}>
              Existem várias razões pelas quais isso pode ter ocorrido,
              incluindo:
            </p>
            <p className={styles.houveUmProblema}>&nbsp;</p>
            {
              ['Pix', 'Boleto'].includes(paymentType) ? (
                <ul className={styles.informaesIncorretasDados}>
                  <li className={styles.limiteDeCrditoExcedidoLi}>
                    Informações Incorretas: Dados do comprador mal inseridos.
                  </li>
                  <li className={styles.limiteDeCrditoExcedidoLi}>
                    Bloqueio de Segurança: Transação bloqueada por medidas de
                    segurança.
                  </li>
                  <li className={styles.limiteDeCrditoExcedidoLi}>
                    Problema Técnico: Pode haver um problema com o sistema de geração de {paymentType === 'Pix' ? 'pix' :'boletos'}.
                  </li>
                </ul>
              ) : (
            <ul className={styles.informaesIncorretasDados}>
              <li className={styles.limiteDeCrditoExcedidoLi}>
                Informações Incorretas: Dados do cartão inseridos de forma
                errada.
              </li>
              <li className={styles.limiteDeCrditoExcedidoLi}>
                Limite de Crédito Excedido: Limite do cartão foi ultrapassado.
              </li>
              <li className={styles.limiteDeCrditoExcedidoLi}>
                Bloqueio de Segurança: Transação bloqueada por medidas de
                segurança.
              </li>
              <li className={styles.limiteDeCrditoExcedidoLi}>
                Cartão Expirado: Data de validade do cartão vencida.
              </li>
            </ul>
              )
            }
            <p className={styles.opaPagamentoNo}>Revise os dados preenchidos e tente novamente.</p>
          </div>
        </div>
        <div className={styles.cta} onClick={() => {
            params.slug ? navigate(`/${params.slug}`) : navigate("/")
          } }>
          <img className={styles.icones2} alt="" src="/icones4.svg" />
          <div className={styles.opaPagamentoNo}>Revise os dados preenchidos e tente novamente</div>
          <img className={styles.icones1} alt="" src="/icones9.svg" />
        </div>
      </div>
    </div>
  );
};

export default CheckoutPagamentoCartaoErro;
